import React, { useState } from "react";
import '../Styles/header.css';
import SearchBar from './SearchBar';
import { QuickSearchBook } from "../Services/Books.service";
import { SearchResult } from "../Types/SearchResult.interface";
import {Link} from "react-router-dom";

export default function Header() {
    const [searchResults, setSearchResults] = useState<SearchResult | null>(null);

    const handleSearch = async (query: string) => {
        try {
            const results = await QuickSearchBook(query);
            setSearchResults(results);

            // Stocker les résultats de la recherche dans le localStorage
            localStorage.setItem("quickSearchResult", JSON.stringify(results));

            // Rediriger vers la page de recherche avec le terme de recherche dans l'URL
            window.location.href = `/search/${encodeURIComponent(query)}`;
        } catch (error) {
            console.error("Une erreur s'est produite lors de la recherche :", error);
        }
    };

    return (
        <div>
            <header className="head">
                <div className="overlay">
                    <h1 className={"title"}>Book'Info</h1>
                    <h3>Vos livres à portée de main</h3>

                    <SearchBar onSearch={handleSearch}/>

                    <div className={"links"}>
                        <Link className={"link"} to={"/"}>Accueil</Link>
                        <Link  className={"link"} to={"/advanced-search"}>Recherche avancée</Link>
                    </div>
                </div>
            </header>
        </div>
    );
}
